/** Shared capture contract (requirements section 5). */

export type ProofKind =
  | "PRE_ORDER"
  | "PAYMENT"
  | "EXTERNAL_PAYMENT"
  | "COLLECTION"
  | "RECEIVING"
  | "DELIVERY";

export interface CaptureRequirements {
  photo: boolean;
  gps: boolean;
  signature: boolean;
}

/**
 * Mirrors PROOF_REQUIREMENTS in the API's constants.ts. REQ-CAP-2: behaviour
 * is identical at every call site; only which fields are required varies.
 * The API re-checks this - the copy here only drives the UI.
 */
export const PROOF_REQUIREMENTS: Record<ProofKind, CaptureRequirements> = {
  PRE_ORDER: { photo: true, gps: true, signature: false },
  PAYMENT: { photo: true, gps: true, signature: false },
  // A payment against a bill raised on another system. All three, because
  // there is no bill here and so no balance to check the amount against - the
  // customer's signature is the only thing standing behind the figure.
  EXTERNAL_PAYMENT: { photo: true, gps: true, signature: true },
  COLLECTION: { photo: true, gps: true, signature: false },
  RECEIVING: { photo: false, gps: false, signature: false },
  DELIVERY: { photo: true, gps: true, signature: true },
};

export interface GpsFix {
  lat: number;
  long: number;
  accuracyMetres: number;
  takenAt: string;
}

export interface CapturePayload {
  kind: ProofKind;
  gps?: GpsFix;
  /** Downscaled JPEG data URL. */
  photoDataUrl?: string;
  /** PNG data URL from the signature canvas. */
  signatureDataUrl?: string;
  notes?: string;
  /** Device clock at capture. The server records its own time too. */
  clientCapturedAt: string;
}
